module.exports = "<md-slider-container> <md-slider ng-model=$ctrl.value ng-disabled=true ng-readonly=true step=1 min=0 max={{$ctrl.max}} md-discrete aria-label=Progreso></md-slider> <span>{{$ctrl.value}}/{{$ctrl.max}}</span> </md-slider-container> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-progress-bar/tsz-progress-bar.html
// module id = 140
// module chunks = 1